<template>
  <span>
    <div 
      class="printblack" 
      :style="highlight ? highlightStyle : normalStyle"
      cursor="initial" 
    >
      <span v-html="answerer.nick_name"></span>
    </div>
  </span>
</template>

<script>
export default {
  props: ["answerer", "highlight"],
  computed: {
    normalStyle() {
      return `
        display: flex;
        padding: 4px 12px 4px 4px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border-radius: 56px;
        border: 2px solid rgba(0, 0, 0, 0.20);
        background: linear-gradient(0deg, #FFF 0%, #FFF 100%), linear-gradient(180deg, #32B511 0%, #0E9720 100%);
        margin: 2px;
        pointer-events: none;
      `
    },
    highlightStyle() {
      return `
        display: flex;
        padding: 4px 12px 4px 4px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border-radius: 56px;
        border: 2px solid #D15E02;
        background: linear-gradient(0deg, #FFE4CC 0%, #FFE4CC 100%), linear-gradient(180deg, #32B511 0%, #0E9720 100%);
        margin: 2px;
        pointer-events: none;
      `
    }
  }
};
</script>

<style scoped>
  @media print {

    .printblack {
      color: black;
    }    
  }
  </style>
